import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import CustomFieldList from "go-component/components/CustomField/CustomFieldList";
import { selectOrganization } from "../../../../../../../../services/organizations/selectors";

const AdminCustomFieldsIndexPage = (props: RouteComponentProps) => {
	const organization = useSelector(selectOrganization);
	const { t } = useTranslation("admin");

	return (
		<CustomFieldList
			organization_name={organization?.name ? organization.name : ""}
			routeProps={props}
			customBrowserTabTitle={`${t("lib:go_component.custom_field.header.title")} | ${t(
				"lib:go_component.navigation.admin"
			)}`}
		/>
	);
};

export default AdminCustomFieldsIndexPage;
